import React from "react";
import { Link } from "react-router-dom";

const base =
  "inline-flex items-center justify-center px-7 py-3.5 text-[12px] tracking-[0.22em] uppercase font-medium transition-all duration-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-offwhite";

const variants = {
  primary: "bg-navy text-white hover:bg-navy/90 hover-lift",
  outline: "bg-transparent border border-navy text-navy hover:bg-navy hover:text-white",
  gold: "bg-gold text-navy hover:bg-gold/90 hover-lift",
  ghost: "text-navy hover:text-gold",
};

export default function CTAButton({ to, href, variant = "primary", children, className = "", ...rest }) {
  const cls = `${base} ${variants[variant] || variants.primary} ${className}`;
  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  );
}
